export default "__VITE_ASSET__DEFR3Rnk__"